export const donViTinh = {
  sections: {
    list: { title: 'Đơn vị tính' },
    detail: { title: 'Đơn vị tính' },
  },
  titles: { add: 'Thêm đơn vị tính', edit: 'Sửa đơn vị tính', create: 'Tạo đơn vị tính' },
  columns: {
    code: 'Mã ĐVT',
    summary: 'Tên đơn vị tính',
    note: 'Ghi chú',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã / tên đơn vị tính...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Danh mục đơn vị tính dùng cho hàng hóa.',
    statusAll: 'Tất cả',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  actions: {
    pause: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
  },
  messages: {
    loadError: 'Không tải được danh sách đơn vị tính.',
    deleteSuccess: 'Đã xóa đơn vị tính.',
    noData: 'Không có đơn vị tính.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu đơn vị tính.',
    createSuccess: 'Tạo đơn vị tính thành công',
    statusChanged: 'Đã cập nhật trạng thái.',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} đơn vị tính đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} đơn vị tính',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn đơn vị tính nào để xóa',
  },
  form: {
    tenDonViTinh: 'Tên đơn vị tính',
    maDonViTinh: 'Mã ĐVT (tuỳ chọn)',
    ghiChu: 'Ghi chú',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên đơn vị tính.',
  },
  import: {
    description:
      'File Excel gồm 3 cột: Mã đơn vị tính (tuỳ chọn), Tên đơn vị tính (bắt buộc), Ghi chú (tuỳ chọn). Để trống mã thì hệ thống tự sinh. Có mã trùng sẽ cập nhật.',
    success: 'Đã nhập đơn vị tính từ Excel.',
    failed: 'Nhập đơn vị tính từ Excel thất bại.',
    empty: 'File Excel không có dữ liệu hợp lệ.',
  },
  placeholders: {
    formTitle: 'Đơn vị tính',
    formBody: '',
    tenDonViTinh: 'Nhập tên đơn vị tính',
  },
}
